module.exports = __webpack_public_path__ + "img/model3.e5bae03c.png";